module.exports = __webpack_public_path__ + "static/media/gryphon-house-car-park-foyer.924b9e3b.jpg";